import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';
import type { AxiosProgressEvent } from 'axios';
import { Pass } from '../models/pass';

export class PassService extends BaseService<Pass> {
  override model = Pass;
  override modelName = 'pass';
  override modelLabel = 'Pass';

  async addPhoto(
    pass: Pass,
    image: File,
    options?: { onUploadProgress?: (progressEvent: AxiosProgressEvent) => void },
  ): Promise<ApiResponse<Pass>> {
    const formData = new FormData();
    formData.append('image', image);

    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${pass.objectID()}/addPhoto`,
      data: formData,
      onUploadProgress: options?.onUploadProgress,
    });

    return await this.requestItem(request, Pass);
  }

  async deletePhoto(
    pass: Pass,
  ): Promise<ApiResponse<Pass>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${pass.objectID()}/deletePhoto`,
    });

    return await this.requestItem(request, Pass);
  }
}
